import {TrackInfo} from "../../model/track-info";
import {TrackUtil} from "../../track-util";
import {TrackActionResult} from "../../model/track-action-result";

export class OriginIncomeAction{

    // Ids de status que precisam de profissao
    static readonly idNotProf = ['11839', '11843', '11838', '11841', '11834', '11837', '12230', '11840'];

    // Id da origem microempreendedor
    static readonly businessman = '12229';
    
    //página onde ocorre a ação
    static readonly actionPageId = 'origin-income';
    
    // Proxima pagina caso seja microempreendedor
    static readonly companyPageId = 'company-cnpj';

    // Proxima pagina caso seja microempreendedor
    static readonly professionPageId = 'profession';

    // Proxima pagina caso seja microempreendedor
    static readonly incomeWealthincomePageId = 'income-wealthincome';



    // Paginas que serão removidas caso <> Brasil
    static readonly removeBusinessmanPages = [OriginIncomeAction.professionPageId];

    // Paginas que serão enviadas direto para income
    static readonly removeIncomePages = [OriginIncomeAction.professionPageId, OriginIncomeAction.companyPageId];

    // Paginas que serão enviadas para profissao
    static readonly removeProfessionalPages = [OriginIncomeAction.companyPageId];




    public static execute(data: any, track: TrackInfo[], originalTracks: TrackInfo[]){
        track = TrackUtil.rebuildTracks(this.actionPageId, track, originalTracks);

        const selectedId = data.professionalData.originIncome;
        const filterId = this.idNotProf.find(x => x === selectedId);

        if (selectedId === this.businessman) {
            return new TrackActionResult(data,
                track[track.findIndex(r => r.pageId === this.companyPageId)],
                track.filter(i => !this.removeBusinessmanPages.includes(i.pageId)));
        } else if (filterId !== undefined) {
            return new TrackActionResult(data,
                track[track.findIndex(r => r.pageId === this.incomeWealthincomePageId)],
                track.filter(i => !this.removeIncomePages.includes(i.pageId)));
        } else {
            return new TrackActionResult(data,
                track[track.findIndex(r => r.pageId === this.professionPageId)],
                track.filter(i => !this.removeProfessionalPages.includes(i.pageId)));
        }
        
    }
}